module.exports = __webpack_public_path__ + "img/asset_soETH.768fa7f9.svg";